import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_jewelry_all: FaireCategoryEntity = {
  token: "cat_jewelry-all",
  type: "category",
  name: "All jewelry",
  level: 2,
  parentToken: "cat_jewelry",
  href: "/category/jewelry",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
